module.exports = {
    _home: {
        en: 'home',
        fr: 'accueil'
    },
    _open_positions: {
        en: 'https://apply.workable.com/evolving-web/',
        fr: 'https://apply.workable.com/evolving-web/?lng=fr'
    },
    _apply_now: {
        en: 'https://evolving-web.workable.com',
        fr: 'https://evolving-web.workable.com/?lng=fr'
    }
}